const LOCAL_HOSTS = ['localhost', '127.0.0.1', '0.0.0.0', '::1'];
const LOCAL_API_PORT = '5100';
const PRODUCTION_API_BASE_URL = 'https://api.catchjobs.com';

// Mirrors resolveApiBaseUrl() in the business and control panels: a local build
// talks to the API on the dev port, anything else talks to production.
export const resolveApiBaseUrl = () => {
  if (typeof window === 'undefined') return `http://localhost:${LOCAL_API_PORT}`;

  const host = window.location.hostname;
  if (LOCAL_HOSTS.indexOf(host) !== -1) {
    const apiHost = host === '0.0.0.0' ? 'localhost' : host;
    return `http://${apiHost}:${LOCAL_API_PORT}`;
  }

  return PRODUCTION_API_BASE_URL;
};

export const apiUrl = (path) => `${resolveApiBaseUrl()}${path}`;
